import logger from "lib/log";
import { call, select, take, put } from "redux-saga/effects";
import {isCheckoutWindowOpen, getServerIDForStudent} from "state/school_money/selectors";
import { fetchAll, STUDENTS_FETCH_COMPLETED, ACTIVE_PAYMENTS_FETCH_COMPLETED } from "state/school_money/actions";
import { closeLoadingFrame } from "state/app/actions";

import * as metadataSagas from "state/school_money/sagas/processMetadataSaga/metadataSagas";

const NOTIFICATION_TYPES = ["payment", "club_booking", "dinner_booking", "shop_item", "overdue", "consent", "shop_collection_reminder"];

/**
 * Refresh all APIs
 */
function* refresh(forceSchoolFetch, forceStudentFetch, forceParentFetch, forceActivePaymentFetch, forceShopFetch, forceHistoryFetch) {
  yield put(fetchAll(forceSchoolFetch, forceStudentFetch, forceParentFetch, forceActivePaymentFetch, forceShopFetch, forceHistoryFetch));
}

// Prevents app refresh if CheckoutWindow is open
function* waitForCheckoutWindowToClose(){
  while ((yield select(isCheckoutWindowOpen))) {
    yield take();
  }
}

export default function* processMetadataSaga(action) {

  yield call(waitForCheckoutWindowToClose);

  // Check for empty metadata passed from native
  if (action.payload.metadata === "") {
    return;
  }

  // respond to refresh
  if (action.payload.metadata === "refresh") {
    // forceSchoolFetch, forceStudentFetch, forceParentFetch, forceActivePaymentFetch, forceShopFetch, forceHistoryFetch
    yield call(refresh, false, false, false, false, false, false);
    yield put(closeLoadingFrame());
    return;
  }

  let metadata;
  try {
    metadata = JSON.parse(action.payload.metadata);
  } catch (err) {
    // this isn't a JSON notification - it's not for us
    yield put(closeLoadingFrame());
    return;
  }

  // If this is unwanted student mis id passed from eduspot then do nothing and close the loading frame
  if (metadata.student_idaas_id !== undefined) {
    yield put(closeLoadingFrame());
    return;
  }

  // If the metadata is coming from eduspot timeline then it won't have additional details from appserver like serverID, application
  // So we need to check and add this for now until we can update Eduspot to send formatted data similar to appserver
  // All the metadata from SM has studentID and type
  if (metadata.application === undefined) {
    if (NOTIFICATION_TYPES.includes(metadata.type) &&
        metadata.hasOwnProperty("payload") &&
        metadata.payload.hasOwnProperty("studentID")) {
          metadata.application = "school_money";
        }
  }

  // check if we need to handle this
  if (metadata.application !== "school_money") {
    return;
  }

  // Do all the required data fetches and wait till their corresponding set actions are done
  // refresh student, shop and payment data
  // forceSchoolFetch, forceStudentFetch, forceParentFetch, forceActivePaymentFetch, forceShopFetch, forceHistoryFetch
  yield call(refresh, false, true, false, true, true, false);
  yield take(STUDENTS_FETCH_COMPLETED);
  yield take(ACTIVE_PAYMENTS_FETCH_COMPLETED);

  // Lets process the serverID if required
  if (metadata.serverID === undefined) {
    metadata.serverID = yield select(getServerIDForStudent, metadata.payload.studentID);
  }

  switch (metadata.type) {
    case "payment":
      yield call(metadataSagas.payment, metadata);
      break;
    case "club_booking":
      yield call(metadataSagas.clubBooking, metadata);
      break;
    case "dinner_booking":
      yield call(metadataSagas.dinnerBooking, metadata);
      break;
    case "shop_item":
      yield call(metadataSagas.shopItem, metadata);
      break;
    case "overdue":
      yield call(metadataSagas.overdue, metadata);
      break;
    case "consent":
      yield call(metadataSagas.consent, metadata);
      break;
    case "shop_collection_reminder":
      logger.log("Process Metadata: school_money: got \"shop_collection_reminder\", taking no action.");
      break;
    default:
      logger.warn(`Process Metadata: school_money: unrecognised metadata type: ${metadata.type}`);
      break;
  }

  yield put(closeLoadingFrame());
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/processMetadataSaga/index.js